import React,{useState,Fragment} from 'react'
import { Col, Container, Row } from "reactstrap";
import { Link } from "react-router-dom";
import { Home } from "react-feather";
import VendorDetails from './VendorDetails';
import VendorTrips from './VendorTrips';
import VendorDriver from './VendorDriver';
import FilterTable from '../../Common/Component/FilterTable';
import SearchTable from '../../Common/Component/SearchTable';
const VendorProfile = () => {
    const [vendorList,setVendorList] = useState('Trips')
  return (
    <Fragment>
      <Container fluid={true}>
        <div className="page-title">
          <Row>
            <Col xs="6">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link
                    to={`${process.env.PUBLIC_URL}/${localStorage.getItem('homePage')}`}
                  >
                    <Home />
                  </Link>
                </li>
                <li className="breadcrumb-item">{"Vendor"}</li>
                <li className="breadcrumb-item">{"Vendor Listing"}</li>
                <li className="breadcrumb-item active">{"Vendor Profile"}</li>
              </ol>
            </Col>
          </Row>
        </div>
        <Col xs="12">
          <VendorDetails />
        </Col>
        {/* <Col md="12" className="vendor-list-details">
          <div>
            <FilterTable />
          </div>
          <div>
            <Row className="trip-options">
              <div>
                <ul className="booking-tabs">
                  <li className={`${vendorList=='Trips'?'active':''}`} onClick={()=>setVendorList('Trips')}>
                    Trips
                    <div className="arrow-down"></div>
                  </li>
                  <li className={`${vendorList=='Driver'?'active':''}`} onClick={()=>setVendorList('Driver')}>
                    Driver
                    <div className="arrow-down"></div>
                  </li>
                </ul>
              </div>
            </Row>
          </div>
          <div className="search-table">
            <SearchTable />
          </div>
        </Col> 
          <Col className="vendor-list-data">
          {vendorList=='Trips'?<VendorTrips/>:''}
          {vendorList=='Driver'?<VendorDriver/>:''}
        </Col> */}
      </Container>
    </Fragment>
  )
}

export default VendorProfile